<template>
  <ion-page>
    <ion-content>

  <div style="color: #222">
    <div style="text-align: right;width: 100%; margin-top:2vh">
      <ion-button @click="cancel()" fill="clear" color="light">
        Hủy chọn <ion-icon :icon="closeCircle" slot="end" color="dark"></ion-icon>
      </ion-button>
    </div>
    <ion-slides ref="slider" :pager="true" :options="slideOpts">
      <ion-slide v-for="(card) in dataCards" :key="card.id">

        <div class="card">
          <div class="title">
            {{ card.id }}
          </div>
          <div class="selected">
            <div style="color: #999; margin: 1.5vh auto;">
              Số được chọn
            </div>
            <div style="display: flex; justify-content: center">
              <span v-if="subgame == '4droll1'">
                <span>&#x2217;</span>
              </span>
              <span v-for="i in numsToPick" :key="i">
                <span v-if="selected[card.id].length > 0">{{ selected[card.id][i-1] }}</span>
              </span>
              <span v-if="subgame == '4droll4'">
                <span>&#x2217;</span>
              </span>
            </div>
          </div>
          <div class="selection">
            <template v-if="subgame == '4droll1'">
              <span v-for="(n, val) in 10" :key="val">
                <span class="disabled-ball">{{ val }}</span>
              </span>
            </template>
            <template v-for="idx in numsToPick" :key="idx">
              <span v-for="(n, val) in 10" :key="val">
                <span v-if="selected[card.id][idx-1] != val" @click="selectBall(card, val, idx-1)">{{ val }}</span>
                <span v-else class="selected-ball" >{{ val }}</span>
              </span>
            </template>
            <template v-if="subgame == '4droll4'">
              <span v-for="(n, val) in 10" :key="val">
                <span class="disabled-ball">{{ val }}</span>
              </span>
            </template>
          </div>
          <div class="footer">
            <div class="foot-title">{{ card.id }}</div>
            <div class="toolbox">
              <ion-button @click="randomPick(card)" fill="clear" size="small" color="light">
                Ngẫu nhiên <ion-icon :icon="dice" slot="end"></ion-icon>
              </ion-button>
              <ion-button @click="clearPick(card)" fill="clear" size="small" color="light">
                Xóa <ion-icon :icon="trash" slot="end"></ion-icon>
              </ion-button>
            </div>
          </div>
        </div>
      </ion-slide>
    </ion-slides>
    <div style="text-align: center">
      <ion-button @click="confirmCards()" fill="solid" color="success">
        Xác nhận
      </ion-button>
    </div>
  </div>
    </ion-content>
  </ion-page>
</template>

<style scoped>
  ion-content {
    --background: transparent;
  }

  ion-slide {
    padding-bottom: 5vh;
    width: 70vw;
    flex-direction: column;
    font-size: 1em;
    /*font-weight: 200;*/
  }

  .card {
    width: 100%;
    background: #fff;
    border-radius: 10px;
    display: flex;
    flex-direction: column;
  }

  .card .title {
    background: #ff34d7;
    color: white;
    font-weight: 700;
    text-align: left;
    padding: 1vw;
    border-top-right-radius: 10px;
    border-top-left-radius: 10px;
    width: 100%;
  }
  .card .selection {
    display: grid;
    grid-auto-flow: column;
    grid-template-rows: repeat(10, 1fr);
    padding: 0 14vw;
  }
  .card .selection > span {
    margin-top: 0.6vh;
    display: flex;
    justify-content: center;
  }

  .card .selection > span > span {
    display: flex;
    align-items: center;
    justify-content: center;
    width: 7.5vw;
    height: 7.5vw;
    border: 1px solid #888;
    color: #666;
    border-radius: 100%;
    font-size: 1em;
  }

  .card .selection > span > span.selected-ball  {
    color: white;
    background: #480f40;
    border: 1px solid #480f40;
  }

  .card .selection > span > span.disabled-ball  {
    color: white;
    background: #480f40;
    border: 1px solid #480f40;
    opacity: 0.5;
  }



  .card .selected {
    margin-bottom: 1vh;
  }

  .card .selected div > span {
    width: 7vw;
    height: 7vw;
    border-bottom: 2px solid #999;
    margin: 0 1vw;
  }
  .card .footer .foot-title {
    text-align: right;
    margin: 0.5vh 1vw;
    color: #f60;
    font-weight: bold;
  }

  .card .footer .toolbox {
    background: #ff34d7;
    color: white;
    font-weight: 700;
    text-align: right;
    padding: 1vw;
    border-bottom-right-radius: 10px;
    border-bottom-left-radius: 10px;
    width: 100%;
    display: flex;
    flex-direction: row;
    justify-content: space-between;
  }

  .card .footer .toolbox button {
    background: transparent;
    color: white;
    margin: 1vw 3vw;
  }
</style>

<script>
  import { defineComponent } from 'vue';
  import {
    IonSlides,
    IonSlide,
    IonIcon,
    IonPage,
    IonContent,
    IonButton,
    modalController
  } from '@ionic/vue';
  import { dice, trash, closeCircle } from 'ionicons/icons';
  import { cloneDeep, random, clone } from 'lodash';

  export default defineComponent({
    name: 'Max4dPick',
    props: ['cards', 'selectedIndex', 'subgame', 'numsToPick', 'numbers'],
    components: {
      IonSlides,
      IonSlide,
      IonButton,
      IonIcon,
      IonPage,
      IonContent,
    },
    data() {
      return {
        maxNum: 10,

        selected: {
          A: [],
          B: [],
          C: [],
          D: [],
          E: [],
          F: [],
        },
        dataCards: [],
        slideOpts: {
          initialSlide: 0,
          speed: 400,
          init: false,
          slidesPerView: 'auto',
          centeredSlides: true,
          spaceBetween: 15,
        }
      }
    },
    methods: {
      randomPick(card) {
        this.selected[card.id] = [];
        const picks = [];
        while (picks.length < this.numsToPick) {
          const pick = random(0, 9, false);
          picks.push(pick);
        }
        this.selected[card.id] = picks;
      },
      clearPick(card) {
        this.selected[card.id] = [];
      },
      cancel() {
        modalController.dismiss({
          cancel: true
        });
      },
      confirmCards() {
        for (const [key, value] of Object.entries(this.selected)) {
          if (
            value.length == this.numsToPick
            && (value.length - value.filter((n) => !isNaN(n)).length == 0))
          {
            this.dataCards.forEach((item, index) => {
              if (item.id == key) {
                this.dataCards[index].nums = this.selected[item.id];
                this.dataCards[index].selected = true;
              }
            })
          } else if (value.length == 0) {
            this.dataCards.forEach((item, index) => {
              if (item.id == key) {
                this.dataCards[index].nums = [];
                this.dataCards[index].selected = false;
              }
            })
          } else {
            this.$utils.toast("Số chọn chưa hợp lệ!");
            this.$refs.slider.$el.slideTo(key.charCodeAt(0)-65);
            return false;
          }
        }
        modalController.dismiss({
          dataCards: this.dataCards
        });
      },
      selectBall(card, val, position) {
        this.selected[card.id][position] = val;
      }
    },
    mounted() {
      this.dataCards = cloneDeep(this.cards);
      this.dataCards.forEach((card) => {
        this.selected[card.id] = clone(card.nums);
      })
      this.$refs.slider.$el.getSwiper().then((instance) => {
        setTimeout(() => {
          if (this.selectedIndex > 0)
            instance.on('init', () => {
              instance.slideTo(this.selectedIndex,500);
            });

          instance.init();
        },10);
      });

    },
    setup() {
      return {
        dice,
        trash,
        closeCircle
      }
    }
  });
</script>
